import React, { useState, useEffect } from 'react';
import { Box, Collapse, Container, Grid, Typography, Stack, Link as MuiLink } from '@mui/material';
import Link from 'next/link';
import getConfig from 'next/config';
import theme from '../../../theme/theme';
import styles from '../styles';
import useComponentVisible from '../../../hooks/useComponentVisible';

const { publicRuntimeConfig } = getConfig();

const DropdownMenu = ({ handleClose, nav }) => {
  const [expand, setExpand] = useState(false);
  const [, setData] = useState(null);
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(true);

  useEffect(() => {
    if (nav) {
      setExpand(Boolean(nav));
      setData(nav);
      setIsComponentVisible(Boolean(nav));
    } else {
      setExpand(false);
      setData(null);
    }
  }, [nav]);

  useEffect(() => {
    if (!isComponentVisible) {
      handleClose();
    }
  }, [isComponentVisible]);

  return (
    <Container maxWidth='auto' sx={styles.mainNavStyle.dropdownContainer} ref={ref}>
      <Container maxWidth='lg'>
        {isComponentVisible && (
          <Collapse in={expand} onClose={handleClose} timeout='auto' unmountOnExit>
            <Grid
              container
              direction='row'
              alignItem='center'
              sx={styles.mainNavStyle.gridContainer}
            >
              <Grid item xs={4}>
                <Stack direction='column'>
                  <Box sx={{ p: 2, mb: 3, cursor: 'text' }}>
                    <MuiLink
                      href=''
                      variant='h5'
                      sx={{
                        textDecoration: 'none',
                        pointerEvents: 'none',
                        color: theme.palette.primary.textColor3,
                      }}
                      onClick={e => {
                        e.preventDefault();
                      }}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                        }
                      }}
                    >
                      {nav?.title}
                    </MuiLink>
                  </Box>
                  <Typography
                    sx={{
                      p: 1,
                      pl: 2,
                      cursor: 'text',
                      color: theme.palette.primary.textColor3,
                    }}
                    variant='body1'
                  >
                    Featured
                  </Typography>
                  <Box
                    component='img'
                    sx={{
                      p: 1,
                      pl: 2,
                      mt: -1,
                      mb: 5,
                      width: 280,
                      height: 223,
                    }}
                    tabIndex={0}
                    role='link'
                    alt={nav?.image?.data?.attributes?.alternativeText}
                    src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${nav?.image?.data?.attributes?.url}`}
                    onClick={() => {
                      window.open(nav?.Link?.link, '_self');
                    }}
                    onKeyDown={e => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        window.open(nav?.Link?.link, '_self');
                      }
                    }}
                  />
                </Stack>
              </Grid>

              <Grid item container sm={8} direction='row' justifyContent='flex-end'>
                {nav?.PrimaryNavL2?.map((link, linkIndex) => (
                  <Grid item sm={6} spacing={4} sx={{ p: 2 }} key={linkIndex}>
                    <MuiLink
                      href=''
                      sx={{
                        pointerEvents: 'none',
                        textDecoration: 'none',
                        color: theme.palette.primary.textColor3,
                      }}
                      variant='h5'
                      onClick={e => {
                        e.preventDefault();
                      }}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                        }
                      }}
                    >
                      {link?.title}
                    </MuiLink>
                    {link?.PrimaryNavL3?.map((data, l3Index) =>
                      data?.Link?.map((menuLink, i) => {
                        const isLast =
                          linkIndex === nav.PrimaryNavL2.length - 1 &&
                          l3Index === link.PrimaryNavL3.length - 1 &&
                          i === data.Link.length - 1;
                        return (
                          <Box key={i} sx={{ display: 'block' }}>
                            <Link href={menuLink?.link} passHref legacyBehavior>
                              <Typography
                                role='link'
                                aria-label={menuLink?.ariaLabel}
                                // onClick={handleClose}
                                onClick={() => {
                                  handleClose();
                                  window.location.href = menuLink?.link;
                                }}
                                variant='body1'
                                // tabIndex={0}
                                component='a'
                                onKeyDown={e => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handleClose();
                                    e.currentTarget.click();
                                  }
                                  if (e.key === 'Tab' && !e.shiftKey && isLast) {
                                    handleClose();
                                  }
                                }}
                                sx={{
                                  ...styles.mainNavStyle.navLinks,
                                  display: 'inline-block',
                                  margin: '0.5rem 0',
                                  padding: 0,
                                }}
                              >
                                {menuLink?.title}
                              </Typography>
                            </Link>
                          </Box>
                        );
                      })
                    )}
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Collapse>
        )}
      </Container>
    </Container>
  );
};

export default DropdownMenu;
